import { initLoading } from './loading.js';
import { initNavigation } from './navigation.js';
import { initAccordion } from './accordion.js';

function boot() {
  initLoading();
  initNavigation();
  initAccordion();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
